import React, { Component } from 'react';
// import { findDOMNode } from 'react-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import { absoluteUrl } from '../../utils/url';
import { updateMetaData } from '../../actions/metaDataActions';
import * as playerActions from '../../actions/playerActions';
import ActiveItem from './ActiveItem';
import ListItem from './ListItem';
import ListGroup from './ListGroup';


class Playlist extends Component {
  constructor (props) {
    super(props);
    this.state = {
      expandedGroup: null,
      playerUid: null,
      // playerShouldAutostart: false,
      // autoPlay: true,
      mobileListOpen: false,
      baseUrl: '',
    };
    this.listContainer = null;
    this.listItemRefs = {};
    this.selectItem = this.selectItem.bind(this);
    this.handlePlayerInit = this.handlePlayerInit.bind(this);
    this.handleItemClick = this.handleItemClick.bind(this);
    this.handleChildItemClick = this.handleChildItemClick.bind(this);
    this.handleGroupClick = this.handleGroupClick.bind(this);
    // this.handleGroupThumbClick = this.handleGroupThumbClick.bind(this);
    // this.handleAutoPlayToggle = this.handleAutoPlayToggle.bind(this);
    this.handlePlayerEnd = this.handlePlayerEnd.bind(this);
    this.handleListLabelClick = this.handleListLabelClick.bind(this);
    this.setMetaData = this.setMetaData.bind(this);
    this.urlFromUid = this.urlFromUid.bind(this);
  }

  UNSAFE_componentWillMount () { // eslint-disable-line camelcase
    const { routeProps: { match }, activeItemId } = this.props;
    const expandedGroup = this.selectItem(activeItemId).group || null;
    const baseUrl = match.url.split('/').slice(0, -1).join('/');
    this.setState({ expandedGroup, baseUrl });
  }

  componentDidMount () {
    this.setMetaData();
  }

  componentDidUpdate (prevProps, prevState) {
    const { activeItemId } = this.props;
    if (activeItemId !== prevProps.activeItemId) {
      this.setMetaData();
      const prevItem = this.selectItem(prevProps.activeItemId);
      const nextItem = this.selectItem(activeItemId);
      if (
        (!prevItem.group && !nextItem.group) || (prevItem.group !== nextItem.group)
      ) {
        // Wait for child list animations to complete
        // so that element offsets are calculated correctly

        this.setState({ expandedGroup: nextItem.group || null });
      }
    }
  }

  componentWillUnmount () {
    this.setMetaData(true);
  }

  handlePlayerInit (uid) {
    this.setState({ playerUid: uid });
    // const { breakpoint, actions } = this.props;
    // const { playerShouldAutostart } = this.state;
    // this.setState({ playerUid: uid }, () => {
    //   if (playerShouldAutostart && breakpoint.greaterThanOrEqual.lg) {
    //     actions.playerStart(uid);
    //   }
    // });
  }

  handleItemClick () {
    this.setState({
      expandedGroup: null,
      // playerShouldAutostart: true,
      mobileListOpen: false,
    });
  }

  handleChildItemClick () {
    this.setState({
      // playerShouldAutostart: true,
      mobileListOpen: false,
    });
  }

  handleGroupClick (uid) {
    const { expandedGroup } = this.state;
    const newState = {
      expandedGroup: expandedGroup === uid ? null : uid,
    };
    // if (expandedGroup !== uid) {
    //   newState.autoPlay = false;
    // }
    this.setState(newState);
  }

  // handleGroupThumbClick (uid) {
  //   // When a group's thumbnail is clicked, navigate
  //   // to the first item within that group
  //   const { routeProps: { history }, itemsOrdered } = this.props;
  //   const { baseUrl } = this.state;
  //   const groupItem = itemsOrdered.find(item => item.uid === uid);
  //   if (groupItem && groupItem.childItems) {
  //     const firstChildUid = groupItem.childItems[0];
  //     const path = this.urlFromUid(firstChildUid);
  //     history.push(`${baseUrl}/${path}`);
  //     this.setState({
  //       expandedGroup: uid,
  //       // playerShouldAutostart: true,
  //       mobileListOpen: false,
  //     });
  //   }
  // }

  // handleAutoPlayToggle () {
  //   this.setState({ autoPlay: !this.state.autoPlay });
  // }

  handlePlayerEnd () {
    const { routeProps: { history }, itemsOrdered, activeItemId } = this.props;
    const allIds = itemsOrdered.reduce((arr, { uid, childItems }) => {
      return arr.concat(childItems ? [...childItems] : [uid]);
    }, []);
    const nextId = allIds[allIds.indexOf(activeItemId) + 1];
    const path = this.urlFromUid(nextId);
    history.push(path);

    // if (this.state.autoPlay) {
    //   const { routeProps: { history }, itemsOrdered, activeItemId } = this.props;
    //   const allIds = itemsOrdered.reduce((arr, { uid, childItems }) => {
    //     return arr.concat(childItems ? [...childItems] : [uid]);
    //   }, []);
    //   const nextId = allIds[allIds.indexOf(activeItemId) + 1];
    //   this.setState({ playerShouldAutostart: true });
    //   const path = this.urlFromUid(nextId);
    //   history.push(path);
    // }
  }

  handleListLabelClick () {
    this.setState({ mobileListOpen: !this.state.mobileListOpen });
  }

  setMetaData (reset = false) {
    const { routeProps: { match }, actions, activeItemId } = this.props;
    const activeItem = this.selectItem(activeItemId);
    const url = absoluteUrl(match.url);
    const { name, shortDescription } = activeItem.media;
    actions.updateMetaData({
      page: reset ? {} : { title: name, shortDescription, url },
    });
  }

  urlFromUid (uid) {
    const { itemUrls } = this.props;
    return Object.keys(itemUrls).find(key => itemUrls[key] === uid);
  }

  selectItem (uid) {
    const { itemsById } = this.props;
    return itemsById[uid];
  }

  renderListItems () {
    const { players, itemsOrdered, activeItemId } = this.props;
    const { baseUrl } = this.state;
    const { expandedGroup, playerUid } = this.state;
    const activePlayer = players[playerUid];
    let progressPercent = 0;
    if (activePlayer && activePlayer.playProgress.percent && !isNaN(activePlayer.playProgress.percent)) {
      progressPercent = activePlayer.playProgress.percent * 100;
    }

    return itemsOrdered.map((item, i) => {
      const { uid, childItems } = item;

      const groupPosterMedia = this.selectItem(uid).groupMedia;
      const firstChildMedia = childItems ? this.selectItem(childItems[0]).media : null;
      return childItems
        ? (
          <ListGroup
            key={uid}
            ref={elem => this.listItemRefs[uid] = elem}
            expanded={expandedGroup === uid}
            active={childItems.includes(activeItemId)}
            posterItem={groupPosterMedia || firstChildMedia}
            onGroupClick={this.handleGroupClick}
            onThumbClick={this.handleGroupClick}
            {...this.selectItem(uid)}
          >
            {childItems.map(childId => (
              <ListItem
                key={childId}
                child
                baseUrl={baseUrl}
                active={activeItemId === childId}
                progress={activeItemId === childId ? progressPercent : null}
                onClick={this.handleChildItemClick}
                {...this.selectItem(childId).media}
              />
            ))}
          </ListGroup>
        ) : (
          <ListItem
            key={uid}
            ref={elem => this.listItemRefs[uid] = elem}
            baseUrl={baseUrl}
            active={activeItemId === uid}
            progress={activeItemId === uid ? progressPercent : null}
            focused={activeItemId === uid && !expandedGroup}
            onClick={this.handleItemClick}
            {...this.selectItem(uid).media}
          />
        );
    });
  }

  render () {
    const { breakpoint, activeItemId } = this.props;
    const { mobileListOpen } = this.state;
    const wrapperClasses = classNames({
      'playlist-itemlist-wrapper': true,
      'h-100': breakpoint.greaterThanOrEqual.md,
      open: breakpoint.lessThan.md && mobileListOpen,
    });
    const listLabelText = mobileListOpen ? 'Close Playlist' : 'Playlist';
    return (
      <div className="playlist-stage">
        <div className="row h-100">
          <div className="col-12 col-md-8" style={{ maxHeight: '100%', overflow: 'auto' }}>
            <div className="playlist-player">
              <ActiveItem
                {...this.selectItem(activeItemId).media}
                onPlayerInit={this.handlePlayerInit}
                onPlayerEnd={this.handlePlayerEnd}
              />
            </div>
          </div>
          <div className={`col-12 col-md-4 ${breakpoint.greaterThanOrEqual.md ? 'h-100' : ''}`}>
            <div className={wrapperClasses}>
              <h4 className="heading-alt color-inherit mb-0 d-md-none" onClick={this.handleListLabelClick}>{listLabelText}</h4>
              <div className="playlist-itemlist" ref={elem => this.listContainer = elem}>
                {this.renderListItems()}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Playlist.propTypes = {
  activeItemId: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.object),
  routeProps: PropTypes.object,
};

const mapStateToProps = ({ breakpoint, players }) => ({ breakpoint, players });

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ ...playerActions, updateMetaData }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Playlist);



// WEBPACK FOOTER //
// ./src/components/Playlist/Playlist.js